import { readCachedOrgFlag, useCachedOrgFlag } from "./useCachedOrgFlag";
const STORAGE_KEY_PREFIX = "codesmith-projects-enabled:";
export function readCachedProjectsEnabled(orgName: string | null): boolean {
  return readCachedOrgFlag(STORAGE_KEY_PREFIX, orgName);
}

/**
 * Cached codesmith projects flag for the session sidebar's Projects nav row.
 * Worst case the row links an org whose flag was just turned off; the
 * projects pages redirect home.
 */
export function useCachedProjectsEnabled(args) {
  return useCachedOrgFlag(STORAGE_KEY_PREFIX, args);
}